<template>
  <div class="form-procesar-materia-prima p-4 mt-4 bg-white border rounded shadow-sm">
    <h3 class="mb-4 text-proceso">Procesar Materia Prima</h3>

    <form @submit.prevent="submitForm">
      <!-- Origen -->
      <div class="seccion mb-4">
        <h6>Materia Prima Origen</h6>
        <p class="mb-1">
          <strong>{{ materia_prima.codigo }}</strong> - {{ materia_prima.nombre }} 
          ({{ materia_prima.stock_disponible }} {{ materia_prima.unidad_medida }})
        </p>
        <div class="row">
          <div class="col-md-6">
            <label>Tipo de Proceso</label>
            <input v-model="form.tipo_proceso" type="text" class="form-control" placeholder="Ej: Extracción, Prensado" required />
          </div>
        </div>
      </div>

      <!-- Cantidad a usar -->
      <div class="seccion mb-4">
        <h6>Cantidad a Utilizar</h6>
        <div class="row">
          <div class="col-md-6">
            <label>Cantidad a usar</label>
            <input v-model.number="form.cantidad_usada" type="number" step="0.01" class="form-control" placeholder="0.00" required min="0" />
          </div>
          <div class="col-md-6">
            <label>Unidad de Medida</label>
            <input :value="materia_prima.unidad_medida" type="text" class="form-control bg-light" readonly />
          </div>
        </div>
      </div>

      <!-- Resultado -->
      <div class="seccion mb-4">
        <h6>Nueva Materia Prima (Resultado)</h6>
        <div class="row g-3">
          <div class="col-md-6">
            <label>Tipo de Materia Prima</label>
            <select v-model="form.resultado_tipo" class="form-select" required>
              <option value="" disabled>Seleccione tipo…</option>
              <option v-for="t in tiposMateria" :key="t.id" :value="t.descripcion">{{ t.descripcion }}</option>
            </select>
          </div>
          <div class="col-md-6">
            <label>Código</label>
            <div class="input-group">
              <input v-model="form.resultado_codigo" type="text" class="form-control bg-light" readonly required />
              <button class="btn btn-outline-proceso" type="button" @click="fetchCodigo">
                <i class="fas fa-sync-alt"></i> Generar
              </button>
            </div>
          </div>
          <div class="col-md-4">
            <label>Cantidad Obtenida</label>
            <input v-model.number="form.resultado_cantidad" type="number" step="0.01" class="form-control" required />
          </div>
          <div class="col-md-4">
            <label>Unidad de Medida</label>
            <select v-model="form.resultado_unidad_medida" class="form-select" required>
              <option value="" disabled>Seleccione…</option>
              <option v-for="u in unidadesMedida" :key="u" :value="u">{{ u }}</option>
            </select>
          </div>
        </div>
      </div>

      <!-- Fechas -->
      <div class="seccion mb-4">
        <h6>Fechas de Vencimiento</h6>
        <div class="row g-3">
          <div class="col-md-6">
            <label>Fecha de Vencimiento</label>
            <input v-model="form.resultado_fecha_vencimiento" type="date" class="form-control" @change="onFechaVencimientoChange" required />
          </div>
          <div class="col-md-6">
            <label>Días hasta vencimiento</label>
            <input v-model.number="form.resultado_dias_vencimiento" type="number" class="form-control" @input="onDiasChange" min="0" />
          </div>
        </div>
      </div>

      <!-- Observaciones -->
      <div class="seccion mb-4">
        <h6>Observaciones</h6>
        <textarea v-model="form.resultado_observaciones" class="form-control" rows="2" placeholder="Notas o detalles"></textarea>
      </div>

      <!-- Botón -->
      <div class="text-end">
        <button type="submit" class="btn btn-proceso">Procesar y Crear Materia Prima</button>
      </div>
    </form>
  </div>
</template>

<script>
import axios from '@/axios';
import { format, addDays, differenceInCalendarDays } from 'date-fns';

export default {
  name: 'ProcesarMateriaPrima',
  props: {
    materia_prima: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      tiposMateria: [],
      unidadesMedida: [],
      form: {
        tipo_proceso: '',
        cantidad_usada: null,
        resultado_tipo: '',
        resultado_codigo: '',
        resultado_cantidad: null,
        resultado_unidad_medida: '',
        resultado_fecha_vencimiento: '',
        resultado_dias_vencimiento: null,
        resultado_observaciones: ''
      }
    };
  },
  computed: {
    club_id() {
      return this.materia_prima.club_id;
    }
  },
  async created() {
    await this.fetchTiposMateria();
    await this.fetchUnidadesMedida();
    await this.fetchCodigo();
  },
  methods: {
    async fetchTiposMateria() {
      const res = await axios.get('/api/constantes/tipos_de_materia_prima');
      this.tiposMateria = res.data;
    },
    async fetchUnidadesMedida() {
      const res = await axios.get('/api/constantes/unidades-medida');
      this.unidadesMedida = res.data;
    },
    async fetchCodigo() {
      const res = await axios.get('/api/materia_prima_generar_codigo', {
        params: {
          club_id: this.club_id,
          materia_prima_id: this.materia_prima.id
        }
      });
      this.form.resultado_codigo = res.data.codigo || '';
    },
    onFechaVencimientoChange() {
      if (this.form.resultado_fecha_vencimiento) {
        this.form.resultado_dias_vencimiento = differenceInCalendarDays(
          new Date(this.form.resultado_fecha_vencimiento),
          new Date()
        );
      }
    },
    onDiasChange() {
      if (this.form.resultado_dias_vencimiento != null) {
        this.form.resultado_fecha_vencimiento = format(
          addDays(new Date(), this.form.resultado_dias_vencimiento),
          'yyyy-MM-dd'
        );
      }
    },
    async submitForm() {
      if (this.materia_prima.stock_disponible < this.form.cantidad_usada) {
        alert('La cantidad a usar excede la disponible.');
        return;
      }

      try {
        const proceso = await axios.post('/api/proceso_transformacion/', {
          tipo: this.form.tipo_proceso,
          descripcion: '',
          fecha_inicio: format(new Date(), 'yyyy-MM-dd'),
          observaciones: ''
        });

        const proceso_id = proceso.data.id;

        await axios.post('/api/transformacion_insumo/', {
          proceso_transformacion_id: proceso_id,
          materia_prima_id: this.materia_prima.id,
          cantidad_usada: this.form.cantidad_usada,
          unidad_medida: this.materia_prima.unidad_medida
        });

        await axios.post(`/api/proceso_transformacion/${proceso_id}/finalizar`, {
          resultados: [
            {
              materia_prima_origen_id: this.materia_prima.id,
              codigo: this.form.resultado_codigo,
              tipo: this.form.resultado_tipo,
              cantidad_obtenida: this.form.resultado_cantidad,
              unidad_medida: this.form.resultado_unidad_medida,
              club_id: this.materia_prima.club_id,
              proyecto_id: this.materia_prima.proyecto_id,
              lote_id: this.materia_prima.lote_id,
              fecha_vencimiento: this.form.resultado_fecha_vencimiento,
              observaciones: this.form.resultado_observaciones
            }
          ]
        });

        alert('Materia prima procesada correctamente');
        this.$emit('procesoFinalizado');
      } catch (error) {
        console.error(error);
        alert('Error al procesar la materia prima');
      }
    }
  }
};
</script>
